import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-pin-location-add",
  "use": "icon-si-glyph-pin-location-add-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-pin-location-add\" id=\"icon-si-glyph-pin-location-add\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>978</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M9.475,0.031 C6.468,0.031 4.032,2.543 4.032,5.64 C4.032,7.224 9.475,15.915 9.475,15.915 C9.475,15.915 14.916,7.306 14.916,5.64 C14.916,2.543 12.479,0.031 9.475,0.031 L9.475,0.031 Z M12.031,6.016 L10.031,6.016 L10.031,8.016 L8.969,8.016 L8.969,6.016 L6.969,6.016 L6.969,4.954 L8.969,4.954 L8.969,2.954 L10.031,2.954 L10.031,4.954 L12.031,4.954 L12.031,6.016 L12.031,6.016 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-pin-location-add.svg
// module id = 9xQg
// module chunks = 62